import { Injectable, inject } from '@angular/core';

import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import type { AdminReportConfiguration } from '@core/account-types';
import { HttpApiService } from '@core/http-legacy';

@Injectable({ providedIn: 'root' })
export class ReportConfigurationHttpClient {
  protected readonly httpApi = inject(HttpApiService);

  public loadReportConfiguration(): Observable<AdminReportConfiguration> {
    return this.httpApi.get('/admin/report', null, null).pipe(map(data => data.adminReport));
  }

  public updateReportConfiguration(
    payload: Partial<AdminReportConfiguration>,
  ): Observable<AdminReportConfiguration> {
    return this.httpApi
      .patch('/admin/report', null, { adminReport: payload })
      .pipe(map(data => data.adminReport));
  }
}
